export default "__VITE_ASSET__DMArA$a$__"